/** Primary Google Font family names — must match families loaded in index.html. */
export const MENU_DISPLAY_DEFAULT_FONT_FAMILY = 'Inter';

export interface MenuDisplayGoogleFontOption {
  label: string;
  /** Value stored in Firebase / used in CSS font-family */
  value: string;
}

/** CSS `font-family` stack for preview / signage (Google Font name + fallback). */
export function menuDisplayFontPreviewCss(family: string | undefined | null): string {
  const name = (family ?? '').trim() || MENU_DISPLAY_DEFAULT_FONT_FAMILY;
  const safe = name.replace(/'/g, '');
  return `'${safe}', sans-serif`;
}

export const MENU_DISPLAY_GOOGLE_FONT_OPTIONS: MenuDisplayGoogleFontOption[] = [
  { label: 'Inter', value: 'Inter' },
  { label: 'Roboto', value: 'Roboto' },
  { label: 'Open Sans', value: 'Open Sans' },
  { label: 'Lato', value: 'Lato' },
  { label: 'Montserrat', value: 'Montserrat' },
  { label: 'Poppins', value: 'Poppins' },
  { label: 'Playfair Display', value: 'Playfair Display' },
  { label: 'Merriweather', value: 'Merriweather' },
  { label: 'Nunito', value: 'Nunito' },
  { label: 'Source Sans 3', value: 'Source Sans 3' },
];
